// The one email rule, the same as the server's (api/src/admin/user.ts): a
// local part, an @, a domain with a dot, no whitespace. Deliberately looser
// than Mantine's isEmail, which refuses apostrophes and non-ASCII letters that
// real addresses carry; the server is the judge and this only stops typos.
const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isEmailAddress(value: string): boolean {
  return EMAIL.test(value.trim());
}

/** A use-form validator with the same rule. */
export function emailRule(message: string) {
  return (value: string) => (isEmailAddress(value) ? null : message);
}
